module.exports = __webpack_public_path__ + "img/dingzhiyansemofakoudai.min.22a39a79.png";